import { getAccountStatusMeta } from '@/settings/components/connected-account-status-meta'
import { PROVIDER_META } from '@/user_files/external-storage/ProviderMeta'
import type { ExternalStorageAccountStatus } from '@/settings/schemas/external-storage-schema'
import type { ExternalStorageProvider } from '@/constants/constants-external-storage'

export type DmsAccountDisplay = {
  provider: ExternalStorageProvider
  displayEmail: string | null
  status: ExternalStorageAccountStatus | null
}

export function ConnectedDmsRow({ account }: { account: DmsAccountDisplay }) {
  const meta = PROVIDER_META[account.provider]
  const statusMeta = account.status ? getAccountStatusMeta(account.status) : null

  return (
    <div className="flex items-center gap-4 px-4 py-4">
      <div className="flex h-[60px] w-[60px] shrink-0 items-center justify-center rounded-md border border-brand-neutral-200 bg-white">{meta.modalIcon}</div>
      <div className="min-w-0 flex-1">
        <p className="font-rethink-sans text-base font-semibold leading-7 tracking-normal text-brand-neutral-950">{meta.label}</p>
        {account.displayEmail && <p className="truncate text-sm leading-5 tracking-[-0.15px] text-brand-neutral-600">{account.displayEmail}</p>}
      </div>
      <span className="flex shrink-0 items-center gap-1 rounded-md px-1.5 py-1 text-sm font-medium leading-5 tracking-[-0.15px] text-brand-neutral-950">
        {statusMeta && <span className={`h-[7px] w-[7px] rounded-full ${statusMeta.dotClassName}`} aria-hidden="true" />}
        {statusMeta?.label ?? 'Status unavailable'}
      </span>
    </div>
  )
}
